import { useProfile } from 'hooks';
import { checkPermissions, checkEveryPermissions } from 'utils/check-permission';
import { ReactNode } from 'react';

type CheckPermissionLayoutProps = {
  permission: number | number[];
  children: ReactNode;
};

function CheckPermissionButton({ permission, children }: CheckPermissionLayoutProps) {
  const { userPermissionIds } = useProfile();

  const isAllow =
    typeof permission === 'number'
      ? checkPermissions(userPermissionIds, permission)
      : checkEveryPermissions(userPermissionIds, permission);

  return isAllow ? <>{children}</> : null;
}

export default CheckPermissionButton;
